import { replaceState } from 'tools/replaceState';
import { smoothScrollTo } from 'tools/smoothScrollTo';

const hash = window.location.hash;
if (hash) {
    const nav = hash.split('#')[1].split('--');
    if (nav.length > 1) {
        const elem = document.querySelector(`#imprint${ nav[0] }`);
        if (elem) {
            const offset = elem.getBoundingClientRect().top + window.pageYOffset;
            smoothScrollTo({ top: offset - 300, behavior: 'smooth' });
        }
    }
}

const hashes = document.querySelectorAll('.tabs [data-hash]');
if (hashes.length) {
    hashes.forEach(hashElement => {
        hashElement.addEventListener('click', () => {
            const hash = hashElement.dataset.hash;
            replaceState(hash);
        });
    });
}
